export const currentUser = (state = {}, action) => {
  switch (action.type) {
    case 'LOAD_USER':
      return action.user;
    default:
      return state;
  }
};

export default currentUser;
